import {Spinner} from "react-bootstrap";

export default function PageLoader({className}: {className?: string}) {
  return <div style={{ height: 200 }} className="d-flex justify-content-center align-items-center">
    <Spinner className={className} animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  </div>
}